var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWethIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 240,
    height: 240,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "A"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h131.949v132.505H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#A)",
    transform: "matrix(1.52313 0 0 1.52313 17.912 17.481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.261 132.506c34 0 34-.507 39.767-2.217 7.533-2.236-21.273-22.177-39.767-22.177S2.773 113.574 2.773 120.31s14.988 12.196 33.488 12.196"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.467 28.785l1.564 1.685-1.365 1.847c-44.345 59.959-69.891 87.105-80.73 83.466-6.6-2.219-13.221-8.888-19.843-18.573-2.327-3.405-4.513-6.99-6.5-10.556-1.323-2.376-2.443-4.542-3.025-5.762a14.36 14.36 0 01-1.3-3.775l-.03-.152a11.87 11.87 0 00-.218-1c-6.222-23.449 2.176-48.347 21.33-63.236a60.46 60.46 0 0166.543-5.072l.23.144q10.967 7.638 23.344 20.985m-26.4-16.356A54.926 54.926 0 007.375 74.547c.12.452.175.706.3 1.361l.025.135a9 9 0 00.871 2.458c.531 1.114 1.6 3.175 2.864 5.449 1.911 3.428 4.01 6.872 6.233 10.127 5.984 8.749 11.915 14.726 17.032 16.445 6.827 2.293 32.523-24.908 73.132-79.648A139.48 139.48 0 0087.067 12.43"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ec1c79",
    d: "M87.067 12.429C67.814 1.772 44.058 3.635 26.702 17.164S1.739 53.275 7.374 74.547c.12.452.175.706.3 1.361l.025.135a9 9 0 00.869 2.462c.531 1.114 1.6 3.175 2.864 5.449 1.911 3.428 4.01 6.872 6.233 10.127 5.984 8.749 11.915 14.726 17.032 16.445 6.831 2.296 32.524-24.904 73.135-79.648a139.48 139.48 0 00-20.765-18.449"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.519 131.95c-33.375 0-60.431-27.056-60.431-60.431s27.056-60.431 60.431-60.431 60.431 27.056 60.431 60.431a60.43 60.43 0 01-60.431 60.431m0-5.544c30.313-.001 54.885-24.574 54.885-54.887S101.83 16.634 71.518 16.634 16.632 41.207 16.632 71.52s24.574 54.885 54.886 54.886"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M71.519 126.407c30.313 0 54.886-24.573 54.886-54.886S101.832 16.635 71.52 16.635 16.634 41.207 16.633 71.52s24.574 54.885 54.886 54.886"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M30.461 82.763l-7.265-21.888h6.366l3.788 12.574 4.189-12.636h5.183l4.191 12.636 3.788-12.574h6.242l-7.265 21.888h-5.246l-4.377-12.511-4.348 12.511zm28.873-.154V60.875h17.48v5.124H65.297v3.291h10.431v4.753H65.297v3.445h11.671v5.124zm26.02 0V66.153h-6.519v-5.278h19.059v5.278h-6.519v16.455zm15.181 0V60.875h6.024v8.133h7.73v-8.133h6.026v21.733h-6.026V74.35h-7.73v8.258z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.602 54.337a3.105 3.105 0 112.777-5.555l8.869 4.437a3.105 3.105 0 01-2.775 5.553zm-1.021 14.71A3.104 3.104 0 015.18 63.41l8.871 4.092a3.105 3.105 0 01-2.6 5.639z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWethIcon);
export default __webpack_public_path__ + "static/media/WETH-icon.2aed6a3eca6f99b5ddb86f17617572a2.svg";
export { ForwardRef as ReactComponent };